import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsRow {
    export const componentId = 'row';

    export interface IColumn {
        size: number;
        components: NICmsContentComponent.IData[];
    }

    export interface IComponentData extends NICmsContentComponent.IData {
        items?: IColumn[];
        gap: number;
    }
}

const gridSize = 12;

@ICmsComponent<CmsRowComponent>({
    id: NCmsRow.componentId,
    name: 'Section',
    isAdvanced: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Columns',
            itemName: 'Column',
            defaultSize: 1,
            minSize: 1,
            maxSize: gridSize,
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'size',
                    title: 'Size',
                    required: true,
                    options: Array.from(Array(gridSize + 1).keys())
                        .map(i => i)
                        .map(number => {
                            return { key: number, title: `${number}` };
                        }),
                    default: 1
                },
                <NICmsContentField.IComponentsField>{
                    type: NICmsContentField.EFieldType.components,
                    key: 'components',
                    title: 'Components'
                    // default: []
                }
            ],
            default: [
                { size: 6, components: [] },
                { size: 6, components: [] }
            ]
        },
        <NICmsContentField.INumberField>{
            type: NICmsContentField.EFieldType.number,
            key: 'gap',
            title: 'Grid Gap',
            min: 0,
            max: gridSize,
            required: true,
            default: 0
        }
    ],
    priority: 50
})
@Component({
    selector: 'cms-row',
    templateUrl: './cms-row.html',
    standalone: true,
    imports: [GridModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsRowComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsRow.IComponentData;

    get columns(): NCmsRow.IColumn[] | undefined {
        if (this.component) {
            let total = 0;
            return this.component.items?.filter(item => {
                if (!item.size) {
                    return false;
                }
                total += item.size;
                return total <= gridSize;
            });
        }
        return undefined;
    }
}
